import { render, staticRenderFns } from "./GuestWrapper.vue?vue&type=template&id=01851b1b"
import script from "./GuestWrapper.vue?vue&type=script&lang=js"
export * from "./GuestWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports